import { getManufacturingOrderCodesForDisplay } from "../../../../utils/manufacturingOrderCode";

export const formatManufacturingOrderCodes = (codes: unknown): string => {
  const displayCodes = getManufacturingOrderCodesForDisplay(codes);

  return displayCodes.length > 0 ? displayCodes.join(", ") : "—";
};
